module.exports = __webpack_public_path__ + "static/media/productBack.1dfd711d.jpg";